import React, {useState} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';



const ScrollArrow = () =>{

  const [showScroll, setShowScroll] = useState(false)

  const checkScrollTop = () => {
    if (!showScroll && window.pageYOffset > 400){
      setShowScroll(true)
    } else if (showScroll && window.pageYOffset <= 400){
      setShowScroll(false)
    }
  };

  const scrollTop = () =>{
    window.scrollTo({top: 0, behavior: 'smooth'});
  };

  window.addEventListener('scroll', checkScrollTop)

  return (
        <div className="scrollTop" onClick={scrollTop} style={{display: showScroll ? 'flex' : 'none'}}>
          <FontAwesomeIcon icon="caret-up"/>
        </div>
  );
}

export default ScrollArrow;